import i18n from "@/i18n";

import { CustomFilter } from "@/types/custom-filter";

import { FalconComplaintFaultEntity } from "@/enums/falcon/complaints/falcon-complaint-fault-entity.enum";
import { I18nMessageKey } from "@/enums/i18n-message-key.enum";

/**
 * @author Damian Kajzer <damian.kajzer@sowlgroup.com>
 * Falcon complaint fault entity filter
 */
export const falconComplaintFaultEntityFilter: CustomFilter = {
  falconComplaintFaultEntity(value: any): string {
    value = +value as FalconComplaintFaultEntity;
    if (value === FalconComplaintFaultEntity.Workshop) {
      value = i18n.t(
        I18nMessageKey.SharedFiltersComplaintFaultEntityWorkshopText
      );
    } else if (value === FalconComplaintFaultEntity.User) {
      value = i18n.t(I18nMessageKey.SharedFiltersComplaintFaultEntityUserText);
    } else {
      value = "";
    }
    return value;
  }
};
